"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flagged = exports.SpecURL = exports.RoadmapDescription = exports.RoadmapTitle = exports.ReleaseNotesDescription = exports.ReleaseNotesTitle = exports.EpicLinkKey = void 0;
exports.EpicLinkKey = 'customfield_10005';
exports.ReleaseNotesTitle = 'customfield_10529';
exports.ReleaseNotesDescription = 'customfield_10530';
exports.RoadmapTitle = 'customfield_10549';
exports.RoadmapDescription = 'customfield_10550';
exports.SpecURL = 'customfield_10551';
exports.Flagged = 'customfield_10200';
//# sourceMappingURL=jiraIssue.js.map